import styled from 'styled-components';

export const CustomPagination = styled.div`
  margin-top: 16px;
  text-align: right;

  .ant-btn:last-child {
    margin-left: 8px;
  }
`;
